import apiClient, { toApiError } from "../client";
import { ApiResponse } from "@/types/api.types";

export interface WatchlistResponse {
  symbols: string[];
}

export const watchlistApi = {
  // Get user's watchlist
  getWatchlist: async (): Promise<string[]> => {
    try {
      const response =
        await apiClient.get<ApiResponse<WatchlistResponse>>("/watchlist");
      return response.data.data.symbols;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Add symbol to watchlist
  addToWatchlist: async (ticker: string): Promise<void> => {
    try {
      await apiClient.post("/watchlist", { ticker, action: "add" });
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Remove symbol from watchlist
  removeFromWatchlist: async (ticker: string): Promise<void> => {
    try {
      await apiClient.post("/watchlist", { ticker, action: "remove" });
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Batch update entire watchlist
  batchUpdateWatchlist: async (symbols: string[]): Promise<void> => {
    try {
      await apiClient.post("/watchlist/update-watchlist", { symbols });
    } catch (error) {
      throw toApiError(error);
    }
  },
};
